import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

export const Landing = () => {
  return (
    <Container className="mx-0 px-0 landing">
      {/* <div className="mt-3 alert alert-primary" role="alert">
        Wannafake is undergoing maintenance and is temporarily unavailable
      </div>
      <div className="alert alert-primary" role="alert">
        Thank you for your understanding, please check back later
      </div> */}
      <Row className="justify-content-center px-3 py-3 section-1">
        <Col align="center" xs={8} sm={6} md={5} lg={4}>
          <h1>Swap faces in your videos</h1>
          <h5>Create fun and original content</h5>
        </Col>
      </Row>
      <Row className="video-row justify-content-center">
        <Col sm={6} md={5} lg={4} className="mx-0 px-0">
          <Link to="/login">
            <div className="player-wrapper">
              <div className="d-flex justify-content-center">
                <ReactPlayer
                  className="react-player fixed-bottom"
                  url="landingVideo.mp4"
                  width="100%"
                  height="100%"
                  volume={0}
                  muted
                  loop
                  playing
                  controls={false}
                  playsinline
                />
              </div>
            </div>
          </Link>
        </Col>
      </Row>
      <Row className="px-3 py-3 cta-row justify-content-center">
        <Col align="center" xs="auto">
          <Button as={Link} variant="primary" to="/login">
            Login
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
